// Widget Label Definitions
// This file defines all customizable labels and style targets for each widget type

export const WIDGET_LABEL_DEFINITIONS = {
    // ============================================================================
    // TABLE WIDGETS - External Risk Scan
    // ============================================================================

    'external-all-findings-table': {
        labels: {
            title: { default: 'External All Findings', editable: true },
            columnHeaders: {
                default: ['Category', 'Finding', 'Status', 'Severity', 'Value'],
                editable: true
            }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            columnHeaders: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            dataRows: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-warnings-table': {
        labels: {
            title: { default: 'External Warnings', editable: true },
            columnHeaders: {
                default: ['Category', 'Finding', 'Severity', 'Value'],
                editable: true
            }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            columnHeaders: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            dataRows: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-passed-table': {
        labels: {
            title: { default: 'External Passed Checks', editable: true },
            columnHeaders: {
                default: ['Category', 'Finding', 'Value'],
                editable: true
            }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            columnHeaders: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            dataRows: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-compliance-table': {
        labels: {
            title: { default: 'Compliance Mapping', editable: true },
            columnHeaders: {
                default: ['Compliance Framework', 'Category', 'Finding', 'Status'],
                editable: true
            }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            columnHeaders: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            dataRows: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    // ============================================================================
    // TABLE WIDGETS - Other
    // ============================================================================

    'open-ports': {
        labels: {
            title: { default: 'Sensitive Open Ports', editable: true },
            columnHeaders: {
                default: ['IP Address', 'Port', 'Service'],
                editable: true
            }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            columnHeaders: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            dataRows: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    // ============================================================================
    // CHART WIDGETS - External Risk Scan
    // ============================================================================

    'external-severity-pie': {
        labels: {
            title: { default: 'External Severity Pie Chart', editable: true }
        },
        styleTargets: ['title'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-status-pie': {
        labels: {
            title: { default: 'External Status Pie Chart', editable: true }
        },
        styleTargets: ['title'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-category-bar': {
        labels: {
            title: { default: 'External Category Bar Chart', editable: true }
        },
        styleTargets: ['title'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    // ============================================================================
    // CHART WIDGETS - Generic
    // ============================================================================

    'pie': {
        labels: {
            title: { default: 'Pie Chart', editable: true }
        },
        styleTargets: ['title', 'legend', 'axisLabels', 'tooltip'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            legend: { fontSize: '12px', fontWeight: '400', color: '#666666', textAlign: 'right' },
            tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
        }
    },
    'bar': {
        labels: {
            title: { default: 'Bar Chart', editable: true }
        },
        styleTargets: ['title', 'legend', 'axisLabels', 'tooltip'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            legend: { fontSize: '12px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            axisLabels: { fontSize: '11px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
        }
    },
    'line': {
        labels: {
            title: { default: 'Line Chart', editable: true }
        },
        styleTargets: ['title', 'legend', 'axisLabels', 'tooltip'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            legend: { fontSize: '12px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            axisLabels: { fontSize: '11px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
        }
    },
    'bubble': {
        labels: {
            title: { default: 'Bubble Chart', editable: true },
            legend: { default: 'Data Labels', type: 'style-only' }
        },
        styleTargets: ['title', 'legend', 'axisLabels', 'tooltip'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#333333', textAlign: 'center' },
            axisLabels: { fontSize: '11px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
        }
    },
    'scatter': {
        labels: {
            title: { default: 'Scatter Plot', editable: true },
            legend: { default: 'Data Labels', type: 'style-only' }
        },
        styleTargets: ['title', 'legend', 'axisLabels', 'tooltip'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#333333', textAlign: 'center' },
            axisLabels: { fontSize: '11px', fontWeight: '400', color: '#666666', textAlign: 'center' },
            tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
        }
    },
    'numeric': {
        labels: {
            title: { default: 'Numeric Display', editable: true },
            value: { default: '0', editable: true },
            label: { default: 'Label', editable: true }
        },
        styleTargets: ['title', 'value', 'label'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            value: { fontSize: '32px', fontWeight: '700', color: '#000000', textAlign: 'center' },
            label: { fontSize: '14px', fontWeight: '400', color: '#666666', textAlign: 'center' }
        }
    },
    'statcard': {
        labels: {
            title: { default: 'Stats Card', editable: true },
            value: { default: '0', editable: true },
            label: { default: 'Label', editable: true }
        },
        styleTargets: ['title', 'value', 'label'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'center' },
            value: { fontSize: '24px', fontWeight: '700', color: '#000000', textAlign: 'center' },
            label: { fontSize: '12px', fontWeight: '400', color: '#666666', textAlign: 'center' }
        }
    },

    // ============================================================================
    // INFO WIDGETS - External Risk Scan
    // ============================================================================

    'external-risk-score': {
        labels: {
            title: { default: 'External Risk Score', editable: true },
            scoreLabel: { default: 'Security Score', editable: true }
        },
        styleTargets: ['title', 'scoreLabel', 'scoreValue'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            scoreLabel: {
                fontSize: '14px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'center'
            },
            scoreValue: {
                fontSize: '36px',
                fontWeight: '700',
                color: '#dc3545', // Dynamic color is usually handled in component, this is fallback
                textAlign: 'center'
            }
        }
    },

    'external-domain-info': {
        labels: {
            title: { default: '🌐 Domain Information', editable: true },
            domainLabel: { default: 'Domain', editable: true },
            ipLabel: { default: 'IP Address', editable: true },
            scanDateLabel: { default: 'Scan Date', editable: true }
        },
        styleTargets: ['title', 'labels', 'values'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            labels: {
                fontSize: '13px',
                fontWeight: '600',
                color: '#495057',
                textAlign: 'left'
            },
            values: {
                fontSize: '13px',
                fontWeight: '400',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-risk-overview': {
        labels: {
            title: { default: 'External Risk Overview', editable: true },
            scoreLabel: { default: 'Security Score', editable: true },
            riskLevelLabel: { default: 'Risk Level', editable: true },
            totalLabel: { default: 'Total Findings', editable: true },
            criticalLabel: { default: 'Critical', editable: true },
            warningsLabel: { default: 'Warnings', editable: true },
            passedLabel: { default: 'Passed', editable: true }
        },
        styleTargets: ['title', 'cardLabels', 'cardValues'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            cardLabels: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#495057',
                textAlign: 'left'
            },
            cardValues: {
                fontSize: '18px',
                fontWeight: '700',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    'external-category-breakdown': {
        labels: {
            title: { default: 'External Category Breakdown', editable: true }
        },
        styleTargets: ['title', 'categoryNames', 'categoryDescriptions'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            categoryNames: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            categoryDescriptions: {
                fontSize: '13px',
                fontWeight: '400',
                color: '#6c757d',
                textAlign: 'left'
            }
        }
    },

    'external-compliance-summary': {
        labels: {
            title: { default: '📜 Compliance Frameworks Referenced', editable: true }
        },
        styleTargets: ['title', 'frameworkNames'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            frameworkNames: {
                fontSize: '12px',
                fontWeight: '500',
                color: '#212529',
                textAlign: 'left'
            }
        }
    },

    // ============================================================================
    // FINDINGS WIDGETS - External Risk Scan
    // ============================================================================

    'external-dns-findings': {
        labels: {
            title: { default: '🔗 Domain & DNS Configuration', editable: true }
        },
        styleTargets: ['title', 'categoryName', 'categoryDescription', 'findingTitles', 'findingDescriptions']
    },

    'external-email-findings': {
        labels: {
            title: { default: '📧 Email Security', editable: true }
        },
        styleTargets: ['title', 'description', 'findingTitles', 'findingDescriptions', 'findingValues'],
        defaultStyles: {
            title: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            description: {
                fontSize: '12px',
                fontWeight: '400',
                color: '#6c757d',
                textAlign: 'left'
            },
            findingTitles: {
                fontSize: '13px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'left'
            },
            findingDescriptions: {
                fontSize: '11px',
                fontWeight: '400',
                color: '#6c757d',
                textAlign: 'left'
            },
            findingValues: {
                fontSize: '11px',
                fontWeight: '400',
                color: '#495057',
                fontFamily: 'monospace',
                textAlign: 'left'
            }
        }
    },

    'external-ssl-findings': {
        labels: {
            title: { default: '🔒 SSL/TLS', editable: true }
        },
        styleTargets: ['title', 'description', 'findingTitles', 'findingDescriptions', 'findingValues'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            description: { fontSize: '12px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingTitles: { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            findingDescriptions: { fontSize: '11px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingValues: { fontSize: '11px', fontWeight: '400', color: '#495057', fontFamily: 'monospace', textAlign: 'left' }
        }
    },

    'external-headers-findings': {
        labels: {
            title: { default: '🛡️ Security Headers', editable: true }
        },
        styleTargets: ['title', 'description', 'findingTitles', 'findingDescriptions', 'findingValues'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            description: { fontSize: '12px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingTitles: { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            findingDescriptions: { fontSize: '11px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingValues: { fontSize: '11px', fontWeight: '400', color: '#495057', fontFamily: 'monospace', textAlign: 'left' }
        }
    },

    'external-infrastructure-findings': {
        labels: {
            title: { default: '☁️ Infrastructure', editable: true }
        },
        styleTargets: ['title', 'description', 'findingTitles', 'findingDescriptions', 'findingValues'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            description: { fontSize: '12px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingTitles: { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            findingDescriptions: { fontSize: '11px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingValues: { fontSize: '11px', fontWeight: '400', color: '#495057', fontFamily: 'monospace', textAlign: 'left' }
        }
    },

    'external-breach-findings': {
        labels: {
            title: { default: '🔓 Breach Intelligence', editable: true }
        },
        styleTargets: ['title', 'description', 'findingTitles', 'findingDescriptions', 'findingValues'],
        defaultStyles: {
            title: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            description: { fontSize: '12px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingTitles: { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            findingDescriptions: { fontSize: '11px', fontWeight: '400', color: '#6c757d', textAlign: 'left' },
            findingValues: { fontSize: '11px', fontWeight: '400', color: '#495057', fontFamily: 'monospace', textAlign: 'left' }
        }
    },





    // ============================================================================
    // CHART WIDGETS - Localhost & Network
    // ============================================================================

    'user-password-status': {
        labels: { title: { default: 'Users Password Status Check', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'disk-free-used': {
        labels: { title: { default: 'Disk Free vs Used', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'firewall-status': {
        labels: { title: { default: 'Firewall Status per Profile', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'service-start-modes': {
        labels: { title: { default: 'Service Start Modes', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'admin-password-status': {
        labels: { title: { default: 'Admin Password Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'password-strength': {
        labels: { title: { default: 'Password Strength Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'hibp-breach-status': {
        labels: { title: { default: 'Email Breach Status (HIBP)', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'windows-version': {
        labels: { title: { default: 'Windows Version Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'common-software': {
        labels: { title: { default: 'Common Software Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'hibp-status': {
        labels: { title: { default: 'HIBP Scan', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'rdp-status': {
        labels: { title: { default: 'RDP Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'browser-status': {
        labels: { title: { default: 'Browsers Password Analysis', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'system-age': {
        labels: { title: { default: 'Device Age Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'open-ports-chart': {
        labels: { title: { default: 'Sensitive vs Other Open Ports', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'device-type': {
        labels: { title: { default: 'Device Type Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'network-sensitive-ports': {
        labels: { title: { default: 'Sensitive vs Other Open Ports', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'network-firewall-status-chart': {
        labels: {
            title: { default: 'Network Firewall Status', editable: true }
        },
        styleTargets: ['title'],
        defaultStyles: {
            title: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#212529',
                textAlign: 'center'
            }
        }
    },

    // ============================================================================
    // CHART WIDGETS - Active Directory
    // ============================================================================

    'ad-object-types': {
        labels: { title: { default: 'Active Directory Object Counts', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ad-objects-pie-chart': {
        labels: { title: { default: 'AD Objects Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'fsmo-roles': {
        labels: { title: { default: 'FSMO Roles Held by Server', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'active-inactive-users': {
        labels: { title: { default: 'AD Users: Active vs Inactive', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'password-expiry': {
        labels: { title: { default: 'Password Expiry: Enabled vs Never Expires', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'active-inactive-computers': {
        labels: { title: { default: 'AD Computers: Active vs Inactive', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'group-types': {
        labels: { title: { default: 'Group Type Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ou-membership': {
        labels: { title: { default: 'Objects per Organizational Unit', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'gpo-timeline': {
        labels: { title: { default: 'GPO Link Settings', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },

    // ============================================================================
    // SUMMARY & COST WIDGETS (Shared Definitions)
    // ============================================================================

    'backups-summary': {
        labels: {
            title: { default: 'Backups Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'admins-finding-summary': {
        labels: {
            title: { default: 'Admins Finding Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'accounts-finding-summary': {
        labels: {
            title: { default: 'Accounts Finding Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'accounts-admin-summary': {
        labels: {
            title: { default: 'Admins Finding Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'firewall-finding-summary': {
        labels: {
            title: { default: 'Firewall Finding Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },

    // ============================================================================
    // COST SUMMARIES (Tables)
    // ============================================================================

    ...[
        'backups-cost-summary',
        'admins-cost-summary',
        'accounts-cost-summary',
        'localhost-firewall-cost-summary',
        'localhost-service-cost-summary',
        'localhost-os-cost-summary',
        'localhost-open-ports-cost-summary',
        'pii-cost-summary',
        'inactive-ms-users-cost-summary',
        'mfa-cost-summary',
        'policy-configuration-cost-summary',
        'softwares-cost-summary',
        'antivirus-cost-summary',
        'encryption-cost-summary',
        'network-encryption-cost-summary',
        'drive-cost-summary',
        'age-cost-summary'
    ].reduce((acc, costType) => {
        acc[costType] = {
            labels: {
                title: { default: 'Cost Summary', editable: true },
                headers: { default: 'Table Headers', type: 'style-only' },
                rows: { default: 'Table Rows', type: 'style-only' }
            },
            styleTargets: ['title', 'headers', 'rows'],
            defaultStyles: {
                title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
                headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
                rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
            }
        };
        return acc;
    }, {}),

    // ============================================================================
    // MS365 & OTHER CHARTS
    // ============================================================================

    'admins-password-status-pie': {
        labels: { title: { default: 'Admins Password Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'accounts-password-pie-chart': {
        labels: { title: { default: 'Accounts Password Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },

    'ms365-users-pie-chart': {
        labels: { title: { default: 'MS365 Users Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ms365-mfa-pie-chart': {
        labels: { title: { default: 'MFA Status Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ms365-policy-pie-chart': {
        labels: { title: { default: 'Policy Configuration Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ms365-admin-roles-chart': {
        labels: { title: { default: 'Admin Roles Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ms365-secure-score-chart': {
        labels: { title: { default: 'Secure Score Breakdown', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'ms365-device-compliance-chart': {
        labels: { title: { default: 'Device Compliance Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'pii-detection-pie-chart': {
        labels: { title: { default: 'PII Detection Summary', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'admins-password-pie-chart': {
        labels: { title: { default: 'Admin Password Policy', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },

    // ============================================================================
    // OTHER SUMMARIES & MISSING WIDGETS
    // ============================================================================

    // EXTERNAL RISK CHARTS (Matching ReportBuilder types)
    'external-severity-pie-chart': {
        labels: { title: { default: 'Severity Distribution', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'external-status-pie-chart': {
        labels: { title: { default: 'Pass/Fail Status', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },
    'external-category-bar-chart': {
        labels: { title: { default: 'Findings by Category', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },

    // AUTO FINDINGS & SUMMARIES

    'key-findings': {
        labels: {
            title: { default: 'Key Findings Summary', editable: true },
            columnHeaders: { default: ['Finding', 'Risk Level', 'Status'], editable: true }
        },
        styleTargets: ['title', 'columnHeaders', 'dataRows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            columnHeaders: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            dataRows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'findings-grid': {
        labels: { title: { default: 'Findings Grid', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' } }
    },


    'accounts-summary': {
        labels: {
            title: { default: 'Accounts Summary', editable: true },
            headers: { default: ['Total Account', 'Non-Expiring Password', 'Percentage'], type: 'style-only' },
            rows: { default: 'Table Rows', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'firewall-summary': {
        labels: { title: { default: 'Firewall Summary', editable: true } },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'overall-risk-score': {
        labels: { title: { default: 'Overall Risk Score', editable: true } },
        styleTargets: ['title'],
        defaultStyles: { title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'center' } }
    },

    // NETWORK / LOCALHOST / COST SUMMARIES

    'total-cost-calculator': {
        labels: {
            title: { default: 'Estimated Revenue Loss Due to Risks', editable: true },
            amount: { default: 'Total Cost Amount', editable: true, type: 'style-only' },
            note: { default: 'Explanatory Note', editable: true, type: 'style-only' }
        },
        styleTargets: ['title', 'amount', 'note'],
        defaultStyles: {
            title: { fontSize: '20px', fontWeight: '700', color: '#111827', textAlign: 'center' },
            amount: { fontSize: '36px', fontWeight: '800', color: '#dc2626', textAlign: 'center' },
            note: { fontSize: '14px', fontWeight: '400', color: '#6b7280', textAlign: 'center' }
        }
    },

    ...[
        'network-firewall-findings-summary',
        'network-service-risk-summary',
        'network-firewall-cost-summary',
        'network-service-cost-summary',
        'network-open-ports-cost-summary',
        'os-risk-summary',
        'os-cost-summary',
        'ad-computer-cost-summary',
        'ad-users-cost-summary',
        'ad-groups-cost-summary',
        'ou-cost-summary',
        'fsmo-cost-summary',
        'gpo-cost-summary',
        'network-detailed-services-table' // Added to replace a duplicate or misplaced item if needed

    ].reduce((acc, type) => {
        acc[type] = {
            labels: {
                title: { default: type.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), editable: true },
                headers: { default: 'Table Headers', type: 'style-only' },
                rows: { default: 'Table Rows', type: 'style-only' }
            },
            styleTargets: ['title', 'headers', 'rows'],
            defaultStyles: {
                title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
                headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
                rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
            }
        };
        return acc;
    }, {}),

    'mfa-summary': {
        labels: {
            title: { default: 'MFA Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'inactive-ms-users-summary': {
        labels: {
            title: { default: 'Inactive MS Users Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'pii-finding-summary': {
        labels: {
            title: { default: 'PII Findings Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'localhost-firewall-findings-summary': {
        labels: {
            title: { default: 'Localhost Firewall Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'localhost-service-risk-summary': {
        labels: {
            title: { default: 'Service Risk Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },
    'service-risk-summary': {
        labels: {
            title: { default: 'Service Risk Summary', editable: true }
        },
        styleTargets: ['title', 'headers', 'rows'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
        }
    },

    // ============================================================================
    // FINDINGS WIDGETS
    // ============================================================================

    'findings-status': {
        labels: {
            title: { default: 'Report of Findings For:', editable: true }
        },
        styleTargets: ['title'],
        defaultStyles: {
            title: { fontSize: '24px', fontWeight: '700', color: '#111827', textAlign: 'left' }
        }
    },

    'single-finding-status': {
        labels: {},
        styleTargets: [],
        defaultStyles: {
            backgroundColor: 'transparent'
        }
    },

    'open-ports-summary': {
        labels: {
            title: { default: 'Open Ports Findings Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            values: { default: 'Table Values', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'values'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            values: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' }
        }
    },
    'darkweb-summary': {
        labels: {
            title: { default: 'Dark Web Scanning Summary', editable: true },
            headers: { default: 'Table Headers', type: 'style-only' },
            values: { default: 'Table Values', type: 'style-only' }
        },
        styleTargets: ['title', 'headers', 'values'],
        defaultStyles: {
            title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
            headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
            values: { fontSize: '14px', fontWeight: '600', color: '#212529', textAlign: 'left' }
        }
    },

    // ============================================================================
    // PROOF TABLES (Using generic DataTable definitions)
    // ============================================================================

    ...[
        // AD Tables
        'ad-all-users-table', 'ad-inactive-users-table', 'ad-all-computers-table',
        'ad-inactive-computers-table', 'ad-groups-risk-table', 'ad-ous-risk-table',
        'ad-fsmo-roles-table', 'ad-gpo-analysis-table', 'ad-admins-table',
        'ad-users-audit-table',
        'ad-computers-audit-table', 'ad-devices-audit-table', 'ad-groups-audit-table',
        'ad-ous-audit-table', 'ad-domain-controllers-audit-table',
        'ad-gpo-policies-audit-table',        'ad-event-logs-audit-table', 'ad-workstation-age-table',

        // Network Tables
        'network-all-users-password-table', 'network-non-expiring-passwords-table',
        'network-admin-daily-work-table', 'network-disk-usage-table',
        'network-logical-disks-table', 'network-backup-status-table', 'network-device-age-table',
        'network-installed-software-table', 'network-os-versions-table',
        'network-users-no-expiring-password-table', 'network-users-expiring-password-table',
        'network-admins-no-expiring-password-table', 'network-admins-expiring-password-table',
        'network-admins-daily-work-table', 'network-non-default-services-table',
        'network-all-open-ports-table', 'network-sensitive-open-ports-table',
        'network-antivirus-status-table', 'network-encryption-status-table',
        'network-firewall-status-table', 'network-detailed-services-table',
        'network-services-risk-breakdown-table', 'network-high-privilege-services-table',
        'software-inventory-table', 'local-administrators-table', 'open-ports-summary',

        // Localhost Tables
        'localhost-all-users-password-table', 'localhost-non-expiring-passwords-table',
        'localhost-disk-usage-table', 'localhost-os-version-table',
        'localhost-sensitive-open-ports-table', 'localhost-services-risk-breakdown-table',
        'localhost-high-privilege-services-table', 'localhost-installed-software-table',
        'localhost-non-default-services-table', 'localhost-open-ports-table',
        'localhost-browser-passwords-table', 'localhost-hardware-information-table',
        'localhost-system-information-table', 'localhost-installed-applications-table',
        'localhost-event-logs-table', 'localhost-open-ports-audit-table',

        // MS365 Tables
        'ms365-inactive-users-table', 'ms365-all-users-mfa-table',
        'ms365-users-without-mfa-table', 'ms365-policy-config-table',
        'ms365-scan-proof-table', 'microsoft-policies-table',

        // External/PII/HIBP Tables
        'hibp-breached-credentials-table', 'hibp-exposure-by-platform-table',
        'pii-detected-table', 'pii-type-summary-table',

        // Generic Widgets (only those not defined specifically above)
        'table', 'donut', 'radar', 'polar', 'gauge'

    ].reduce((acc, tableType) => {
        const isChart = ['bar', 'line', 'pie', 'donut', 'radar', 'polar', 'bubble', 'scatter', 'gauge', 'numeric', 'statcard'].includes(tableType);
        const isDataValue = ['numeric', 'gauge', 'statcard'].includes(tableType);
        
        acc[tableType] = {
            labels: {
                title: { default: isChart ? 'Chart Title' : 'Table Title', editable: true },
                ...(isDataValue ? {
                    value: { default: 'Value', type: 'style-only' },
                    label: { default: 'Label', type: 'style-only' }
                } : {}),
                ...(isChart && !isDataValue ? {} : (isDataValue ? {} : {
                    headers: { default: 'Headers', type: 'style-only' },
                    rows: { default: 'Rows', type: 'style-only' }
                }))
            },
            styleTargets: isDataValue ? ['title', 'value', 'label'] : (isChart ? ['title', 'legend', 'axisLabels', 'tooltip'] : ['title', 'headers', 'rows']),
            defaultStyles: {
                title: { fontSize: '16px', fontWeight: '600', color: '#212529', textAlign: 'left' },
                ...(isDataValue ? {
                    value: { fontSize: '24px', fontWeight: '700', color: '#212529', textAlign: 'center' },
                    label: { fontSize: '14px', fontWeight: '400', color: '#666666', textAlign: 'center' }
                } : {}),
                ...(isChart && !isDataValue ? {} : (isDataValue ? {} : {
                    headers: { fontSize: '12px', fontWeight: '600', color: '#495057', textAlign: 'left' },
                    rows: { fontSize: '12px', fontWeight: '400', color: '#212529', textAlign: 'left' }
                })),
                ...(isChart && !isDataValue ? {
                    legend: { fontSize: '12px', fontWeight: '400', color: '#666666', textAlign: 'center' },
                    axisLabels: { fontSize: '11px', fontWeight: '400', color: '#666666', textAlign: 'center' },
                    tooltip: { fontSize: '12px', fontWeight: '400', color: '#ffffff', textAlign: 'left' }
                } : {})
            }
        };
        return acc;
    }, {}),

    // ============================================================================
    // SCAN GRID WIDGETS
    // ============================================================================

    'infrastructure-scan-grid': {
        labels: { title: { default: 'INFRASTRUCTURE', editable: true } },
        styleTargets: ['title', 'findingHeaders', 'findingDescriptions', 'legend', 'auditScore', 'auditScoreValue'],
        defaultStyles: {
            title: { fontSize: '28px', fontWeight: '700', color: '#6b7280', textAlign: 'left' },
            findingHeaders: { fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center' },
            findingDescriptions: { fontSize: '11px', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#6b7280', textAlign: 'center' },
            auditScore: { fontSize: '13px', fontWeight: '600', color: '#9ca3af', textAlign: 'center' },
            auditScoreValue: { fontSize: '24px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }
        }
    },
    'managed-service-experience': {
        labels: { title: { default: 'MANAGED IT / SERVICE EXPERIENCE', editable: true } },
        styleTargets: ['title', 'findingHeaders', 'findingDescriptions', 'legend', 'auditScore', 'auditScoreValue'],
        defaultStyles: {
            title: { fontSize: '28px', fontWeight: '700', color: '#6b7280', textAlign: 'left' },
            findingHeaders: { fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center' },
            findingDescriptions: { fontSize: '11px', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#6b7280', textAlign: 'center' },
            auditScore: { fontSize: '13px', fontWeight: '600', color: '#9ca3af', textAlign: 'center' },
            auditScoreValue: { fontSize: '24px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }
        }
    },
    'security-scan-grid': {
        labels: { title: { default: 'SECURITY SCAN GRID', editable: true } },
        styleTargets: ['title', 'findingHeaders', 'findingDescriptions', 'legend', 'auditScore', 'auditScoreValue'],
        defaultStyles: {
            title: { fontSize: '28px', fontWeight: '700', color: '#6b7280', textAlign: 'left' },
            findingHeaders: { fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center' },
            findingDescriptions: { fontSize: '11px', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#6b7280', textAlign: 'center' },
            auditScore: { fontSize: '13px', fontWeight: '600', color: '#9ca3af', textAlign: 'center' },
            auditScoreValue: { fontSize: '24px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }
        }
    },
    'cyber-security-threat-exposure': {
        labels: { title: { default: 'CYBER SECURITY (THREAT & EXPOSURE)', editable: true } },
        styleTargets: ['title', 'findingHeaders', 'findingDescriptions', 'legend', 'auditScore', 'auditScoreValue'],
        defaultStyles: {
            title: { fontSize: '28px', fontWeight: '700', color: '#6b7280', textAlign: 'left' },
            findingHeaders: { fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center' },
            findingDescriptions: { fontSize: '11px', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#6b7280', textAlign: 'center' },
            auditScore: { fontSize: '13px', fontWeight: '600', color: '#9ca3af', textAlign: 'center' },
            auditScoreValue: { fontSize: '24px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }
        }
    },
    'combined-scan-grid': {
        labels: { title: { default: 'BASIC SCAN GRID', editable: true } },
        styleTargets: ['title', 'findingHeaders', 'findingDescriptions', 'legend', 'auditScore', 'auditScoreValue'],
        defaultStyles: {
            title: { fontSize: '28px', fontWeight: '700', color: '#6b7280', textAlign: 'left' },
            findingHeaders: { fontSize: '13px', fontWeight: '700', color: '#ffffff', textAlign: 'center' },
            findingDescriptions: { fontSize: '11px', fontWeight: '500', color: '#1f2937', backgroundColor: '#ffffff', textAlign: 'center' },
            legend: { fontSize: '11px', fontWeight: '400', color: '#6b7280', textAlign: 'center' },
            auditScore: { fontSize: '13px', fontWeight: '600', color: '#9ca3af', textAlign: 'center' },
            auditScoreValue: { fontSize: '24px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }
        }
    }
};

// Helper function to format label names for display
export const formatLabelName = (labelKey) => {
    if (labelKey === 'title') return 'Widget Title';
    if (labelKey === 'legend') return 'Legend Information';
    return labelKey
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
        .trim();
};

// Helper function to get nested value from object
export const getNestedValue = (obj, path) => {
    if (typeof path === 'string') {
        return obj?.[path];
    }
    return path.reduce((acc, key) => acc?.[key], obj);
};
